<div *ngIf="visible" class="popup-overlay" (click)="onOverlayClick($event)">
    <div class="popup-content waybill-complete-popup" (click)="$event.stopPropagation()">
        <div class="popup-header">
            <h3 class="popup-title">
                <span class="popup-title-icon">
                    <i class="fas fa-clipboard-check"></i>
                </span>
                Completa Bolla
            </h3>
            <button type="button" class="btn-close" (click)="close()" aria-label="Close">
                <i class="fas fa-times"></i>
            </button>
        </div>

        <div class="popup-body">
            <form [formGroup]="waybillForm" (ngSubmit)="onSubmit()">

                <!-- Waybill Information Section -->
                <div class="details-card mb-3" *ngIf="waybill">
                    <div class="details-card-header">
                        <div class="details-card-icon">
                            <i class="fas fa-barcode"></i>
                        </div>
                        <h5 class="details-card-title">Informazioni Bolla</h5>
                    </div>
                    <div class="details-card-body">
                        <div class="details-grid">
                            <div class="details-item">
                                <span class="details-label">Codice Bolla</span>
                                <div class="details-value details-value--code">
                                    <span>{{ waybill.waybillCode }}</span>
                                </div>
                            </div>
                            <div class="details-item">
                                <span class="details-label">Codice Spedizione</span>
                                <div class="details-value details-value--code">
                                    <span>{{ waybill.waybillShipmentCode }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="details-card mb-3">
                    <div class="details-card-header">
                        <div class="details-card-icon">
                            <i class="fas fa-route"></i>
                        </div>
                        <h5 class="details-card-title">Instradamento e Corriere</h5>
                    </div>
                    <div class="details-card-body">
                    <div class="row">
                        <!-- Routing (Zones) -->
                        <div class="col-md-6 mb-3">
                            <label for="zonesDropdown" class="form-label fw-bold">
                                Instradamento *
                            </label>
                            <div class="dropdown custom-zones-dropdown">
                                <button class="btn w-100 text-start custom-dropdown-btn"
                                        type="button"
                                        id="zonesDropdown"
                                        (click)="toggleZonesDropdown()"
                                        aria-expanded="false"
                                        [class.btn-outline-danger]="isFieldInvalid('waybillDeliveryType')"
                                        [class.btn-outline-secondary]="!isFieldInvalid('waybillDeliveryType')">
                                    <div class="d-flex align-items-center">
                                        <i class="fas fa-route me-2"></i>
                                        <div class="flex-grow-1">
                                            <ng-container *ngIf="!getSelectedZone()">
                                                Seleziona instradamento
                                            </ng-container>
                                            <ng-container *ngIf="getSelectedZone()">
                                                <div class="fw-bold">{{ getSelectedZone() }}</div>
                                                <div class="small text-muted">Zona instradamento</div>
                                            </ng-container>
                                        </div>
                                        <i class="fas fa-chevron-down dropdown-arrow"></i>
                                    </div>
                                </button>

                                <ul class="dropdown-menu w-100 custom-carrier-menu"
                                    [class.show]="isZonesDropdownOpen">
                                    <!-- Search Field -->
                                    <li class="dropdown-search-container" (click)="$event.stopPropagation()">
                                        <div class="position-relative">
                                            <input 
                                                type="text" 
                                                class="form-control search-input" 
                                                placeholder="Cerca zona..." 
                                                [(ngModel)]="zoneSearchTerm"
                                                (click)="$event.stopPropagation()"
                                                [ngModelOptions]="{standalone: true}">
                                            <button 
                                                *ngIf="zoneSearchTerm" 
                                                class="btn btn-sm clear-search-btn"
                                                (click)="clearZoneSearch(); $event.stopPropagation()"
                                                type="button">
                                                <i class="fas fa-times"></i>
                                            </button>
                                        </div>
                                    </li>
                                    <li class="dropdown-divider" *ngIf="!isLoadingZones"></li>
                                    
                                    <!-- Loading State -->
                                    <li *ngIf="isLoadingZones" class="dropdown-item disabled d-flex align-items-center p-3">
                                        <i class="fas fa-spinner fa-spin me-2"></i>
                                        Caricamento zone...
                                    </li>
                                    
                                    <!-- Empty State -->
                                    <li *ngIf="!isLoadingZones && getFilteredZones().length === 0" class="dropdown-item disabled p-3">
                                        <div class="text-center text-muted">
                                            <i class="fas fa-search mb-2"></i>
                                            <div>Nessuna zona trovata</div>
                                        </div>
                                    </li>
                                    
                                    <!-- Zones List with scroll -->
                                    <div class="dropdown-items-container">
                                        <li *ngFor="let zone of getFilteredZones()"
                                            class="dropdown-item d-flex align-items-center p-3 cursor-pointer"
                                            [ngClass]="{'selected': getSelectedZone() === zone}"
                                            (click)="selectZone(zone)">
                                            <div class="d-flex align-items-center w-100">
                                                <i class="fas fa-route me-3"
                                                   [ngClass]="{
                                                     'text-primary': getSelectedZone() === zone,
                                                     'text-muted': getSelectedZone() !== zone
                                                   }"></i>
                                                <div class="flex-grow-1 min-w-0">
                                                    <div class="fw-bold text-truncate"
                                                         [ngClass]="{'text-primary': getSelectedZone() === zone}">{{ zone }}</div>
                                                </div>
                                            </div>
                                        </li>
                                    </div>
                                </ul>
                            </div>

                            <div *ngIf="isFieldInvalid('waybillDeliveryType')" class="invalid-feedback d-block">
                                {{ getFieldError('waybillDeliveryType') }}
                            </div>
                        </div>
                        <!-- Carrier Selection -->
                        <div class="col-md-6 mb-3">
                            <label for="carrierDropdown" class="form-label fw-bold">
                                Corriere *
                            </label>
                            <!-- Custom Dropdown -->
                            <div class="dropdown custom-carrier-dropdown">
                                <button class="btn w-100 text-start custom-dropdown-btn"
                                        type="button"
                                        id="carrierDropdown"
                                        (click)="toggleDropdown()"
                                        [disabled]="isCarrierDisabled()"
                                        [attr.aria-disabled]="isCarrierDisabled()"
                                        [title]="isCarrierDisabled() ? 'Seleziona prima l\'instradamento' : ''"
                                        aria-expanded="false"
                                        [class.btn-outline-danger]="isFieldInvalid('waybillCarrierCode')"
                                        [class.btn-outline-secondary]="!isFieldInvalid('waybillCarrierCode')">
                                    <div class="d-flex align-items-center">
                                        <i class="fas fa-truck me-2 text-muted"></i>
                                        <div class="flex-grow-1">
                                            <ng-container *ngIf="!getSelectedCarrier()">
                                                Seleziona Corriere
                                            </ng-container>
                                            <ng-container *ngIf="getSelectedCarrier()">
                                                <div class="fw-bold">{{ getSelectedCarrier()?.carrierName || getSelectedCarrier()?.carrierCode }}</div>
                                                <div class="small text-muted">
                                                    P.IVA: {{ getSelectedCarrier()?.carrierVatNumber || 'N/A' }} |
                                                    ID: {{ getSelectedCarrier()?.carrierInternalId || 'N/A' }}
                                                </div>
                                            </ng-container>
                                        </div>
                                        <i class="fas fa-chevron-down dropdown-arrow"></i>
                                    </div>
                                </button>

                                <ul class="dropdown-menu w-100 custom-carrier-menu"
                                    [class.show]="isDropdownOpen">
                                    <!-- Search Field -->
                                    <li class="dropdown-search-container" (click)="$event.stopPropagation()">
                                        <div class="position-relative">
                                            <input 
                                                type="text" 
                                                class="form-control search-input" 
                                                placeholder="Cerca corriere..." 
                                                [(ngModel)]="carrierSearchTerm"
                                                (click)="$event.stopPropagation()"
                                                [ngModelOptions]="{standalone: true}">
                                            <button 
                                                *ngIf="carrierSearchTerm" 
                                                class="btn btn-sm clear-search-btn"
                                                (click)="clearCarrierSearch(); $event.stopPropagation()"
                                                type="button">
                                                <i class="fas fa-times"></i>
                                            </button>
                                        </div>
                                    </li>
                                    <li class="dropdown-divider"></li>
                                    
                                    <!-- Empty State -->
                                    <li *ngIf="getFilteredCarriers().length === 0" class="dropdown-item disabled p-3">
                                        <div class="text-center text-muted">
                                            <i class="fas fa-search mb-2"></i>
                                            <div>Nessun corriere trovato</div>
                                        </div>
                                    </li>
                                    
                                    <!-- Carriers List with scroll -->
                                    <div class="dropdown-items-container">
                                        <li *ngFor="let carrier of getFilteredCarriers()"
                                            class="dropdown-item d-flex align-items-center p-3 cursor-pointer"
                                            [ngClass]="{'selected': getSelectedCarrier()?.carrierCode === carrier.carrierCode}"
                                            (click)="selectCarrier(carrier)">
                                            <div class="d-flex align-items-center w-100">
                                                <i class="fas fa-truck me-3"
                                                   [ngClass]="{
                                                     'text-primary': getSelectedCarrier()?.carrierCode === carrier.carrierCode,
                                                     'text-muted': getSelectedCarrier()?.carrierCode !== carrier.carrierCode
                                                   }"></i>
                                                <div class="flex-grow-1 min-w-0">
                                                    <div class="fw-bold text-truncate"
                                                         [ngClass]="{'text-primary': getSelectedCarrier()?.carrierCode === carrier.carrierCode}">
                                                        {{ carrier.carrierName || carrier.carrierCode }}
                                                    </div>
                                                    <div class="small text-muted text-truncate d-flex align-items-center gap-2">
                                                        <span>
                                                            <i class="fas fa-receipt me-1"></i>
                                                            P.IVA: {{ carrier.carrierVatNumber || 'N/A' }}
                                                        </span>
                                                        <span>
                                                            <i class="fas fa-tag me-1"></i>
                                                            ID: {{ carrier.carrierInternalId || 'N/A' }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </div>
                                </ul>
                            </div>

                            <div *ngIf="isFieldInvalid('waybillCarrierCode')" class="invalid-feedback d-block">
                                {{ getFieldError('waybillCarrierCode') }}
                            </div>
                            <div *ngIf="isCarrierDisabled()" class="form-text text-muted">
                                Seleziona prima l'instradamento per abilitare il corriere
                            </div>
                        </div>
                    </div>
                    </div>
                </div>

                <!-- Estimated Delivery Date and Time -->
                <div class="details-card mb-3">
                    <div class="details-card-header">
                        <div class="details-card-icon">
                            <i class="fas fa-calendar-check"></i>
                        </div>
                        <h5 class="details-card-title">Consegna Stimata</h5>
                    </div>
                    <div class="details-card-body">
                    <div class="row">
                        <div class="col-md-6 mb-3">
                            <label for="waybillEstimatedDeliveryDate" class="form-label fw-bold">
                                Data Consegna Stimata *
                            </label>
                            <div class="position-relative">
                                <input type="text"
                                       id="waybillEstimatedDeliveryDate"
                                       #estimatedDateInput
                                       class="form-control ps-5"
                                       formControlName="waybillEstimatedDeliveryDate"
                                       [class.is-invalid]="isFieldInvalid('waybillEstimatedDeliveryDate')"
                                       placeholder="DD/MM/YYYY"
                                       (click)="openDatePicker()"
                                       (focus)="openDatePicker()"
                                       readonly>
                                <i class="fas fa-calendar-alt position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"
                                   style="cursor: pointer; z-index: 10;"
                                   (click)="openDatePicker()"></i>
                            </div>
                            <div *ngIf="isFieldInvalid('waybillEstimatedDeliveryDate')" class="invalid-feedback d-block">
                                {{ getFieldError('waybillEstimatedDeliveryDate') }}
                            </div>
                            <small class="text-muted mt-1 d-block">
                                <i class="fas fa-info-circle me-1"></i>
                                Seleziona la data di consegna prevista o lasciare
                            </small>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label for="waybillEstimatedDeliveryTime" class="form-label fw-bold">
                                Ora Consegna Stimata *
                            </label>
                            <div class="position-relative">
                                <input type="time"
                                       id="waybillEstimatedDeliveryTime"
                                       class="form-control ps-5"
                                       [class.is-invalid]="isFieldInvalid('waybillEstimatedDeliveryTime')"
                                       formControlName="waybillEstimatedDeliveryTime"
                                       placeholder="HH:MM"
                                       pattern="[0-9]{2}:[0-9]{2}"
                                       title="Inserisci l'ora nel formato HH:MM (es. 14:30)"
                                       autocomplete="off"
                                       (change)="updateWaybillEstimatedDelivery()"
                                       (input)="updateWaybillEstimatedDelivery()">
                                <i class="fas fa-clock position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"
                                   style="cursor: pointer;"
                                   (click)="focusTimeInput()"></i>
                            </div>
                            <div *ngIf="isFieldInvalid('waybillEstimatedDeliveryTime')" class="invalid-feedback d-block">
                                {{ getFieldError('waybillEstimatedDeliveryTime') }}
                            </div>
                        </div>
                    </div>
                    </div>
                </div>

            </form>
        </div>

        <div class="popup-footer">
            <div class="popup-footer-bar">
                <span class="popup-footer-hint">
                    <i class="fas fa-info-circle me-1"></i>
                    I campi contrassegnati con * sono obbligatori
                </span>
                <div class="d-flex justify-content-end gap-2">
                <button type="button" class="btn btn-secondary" (click)="close()">
                    <i class="fas fa-times me-2"></i>
                    Annulla
                </button>
                <button type="button"
                        class="btn btn-primary"
                        (click)="onSubmit()"
                        [disabled]="waybillForm.invalid || isSubmitting">
                    <i class="fas fa-save me-2"></i>
                    Completa Bolla
                    <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm ms-2" role="status"></span>
                </button>
                </div>
            </div>
        </div>

    </div>
</div>
